<form>
    <app-form-section [formGroup]="paymentForm">
        <app-form-row-header [title]="'FEATURES.AGREEMENTS.GROUP_TITLE_PAYMENT' | translate" icon="payments" />
        <div class="form">
            <app-form-row>
                <app-form-group
                    ><label for="paymentTerms"
                        >{{ 'FEATURES.AGREEMENTS.PAYMENT_TERMS' | translate }}
                        <app-pdf-reference-icon [fieldName]="agreementMetaDataConstants.PaymentTerms"
                    /></label>
                    <app-dropdown
                        [items]="paymentTermsOptions"
                        formControlName="paymentTerms"
                        [highlightAnimated]="isFieldHighlighted(agreementMetaDataConstants.PaymentTerms)"
                        (highlightFocus)="onFieldFocus(agreementMetaDataConstants.PaymentTerms)"
                    />
                </app-form-group>
                <app-form-group *ngIf="showCustomPaymentTerms()">
                    <label for="customPaymentTerms">&nbsp;</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="customPaymentTerms"
                        formControlName="customPaymentTerms"
                        type="number"
                        min="0"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group
                    ><label for="value"
                        >{{ 'FEATURES.AGREEMENTS.PAYMENT_VALUE' | translate }}
                        <app-pdf-reference-icon [fieldName]="agreementMetaDataConstants.EstimatedAnnualValue"
                    /></label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="value"
                        formControlName="value"
                        type="number"
                        min="0"
                        [ngClass]="{
                            'highlight-animated': isFieldHighlighted(agreementMetaDataConstants.EstimatedAnnualValue)
                        }"
                        (focus)="onFieldFocus(agreementMetaDataConstants.EstimatedAnnualValue)"
                /></app-form-group>
                <app-form-group>
                    <label for="currency">&nbsp;</label>
                    <app-dropdown
                        [items]="currencies$ | async"
                        formControlName="currency"
                        [highlightAnimated]="isFieldHighlighted(agreementMetaDataConstants.EstimatedAnnualValue)"
                        (highlightFocus)="onFieldFocus(agreementMetaDataConstants.EstimatedAnnualValue)"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group
                    ><label for="invoiceIntervalId"
                        >{{ 'FEATURES.AGREEMENTS.INVOICE_INTERVAL' | translate }}
                        <app-pdf-reference-icon [fieldName]="agreementMetaDataConstants.InvoiceInterval"
                    /></label>
                    <app-dropdown
                        [items]="invoiceIntervalsOptions"
                        formControlName="invoiceIntervalId"
                        [highlightAnimated]="isFieldHighlighted(agreementMetaDataConstants.InvoiceInterval)"
                        (highlightFocus)="onFieldFocus(agreementMetaDataConstants.InvoiceInterval)"
                    />
                </app-form-group>
            </app-form-row>
        </div>
    </app-form-section>
</form>
